export const DEFAULT_REQUEST_TIMEOUT: number = 10 * 1000; // 10 seconds
export const DEFAULT_METADATA_REQUEST_TIMEOUT: number = 60 * 1000; // 60 seconds
export const DEFAULT_METADATA_REFRESH_INTERVAL: number = 10 * 60 * 1000; // 10 minutes
export const DEFAULT_METADATA_MIN_RETRY_DELAY: number = 5 * 1000; // 5 seconds
export const DEFAULT_METADATA_MAX_RETRY_DELAY: number = 60 * 60 * 1000; // 60 minutes
export const DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL: number = 10; // 10 milliseconds
